<div
  (click)="handleOfferSelection(offer.data.id, offer.data.status)"
  [ngClass]="{ pointer: offer.data.status !== offerStatuses.declined }"
  class="inquiry-left-content"
>
  <div class="candidate-infos h-100">
    <base-inquiry-employee-avatar-and-name
      [anonymous]="offer.data.anonymous ?? false"
      [avatar]="offer.data.profile.avatar || ''"
      [firstName]="offer.data.profile.firstName"
      [lastName]="offer.data.profile.lastName"
      (click)="openOfferInfoModal(offer, false, $event)"
    ></base-inquiry-employee-avatar-and-name>

    <div class="mb-auto d-flex flex-column">
      <p
        baseTruncate
        class="m-0 main-qualification-text"
      >
        {{ offer.data.mainQualification.name }}
      </p>
      <div
        *ngIf="offer.data.profile.qualifications?.length"
        class="d-inline-block"
      >
        <span
          [ngbTooltip]="qualificationsTooltip"
          class="alternative-qualification-text"
        >
          <ng-container *ngIf="offer.data.profile.qualifications.length > 0">
            + {{ offer.data.profile.qualifications.length }} {{ 'additional' | translate }}
          </ng-container>
        </span>
      </div>
      <ng-template #qualificationsTooltip>
        <div class="fw-bold text-start">
          {{ 'inquiry.otherQualifications' | translate }}
        </div>
        <ul class="list-unstyled text-start mb-0">
          <li *ngFor="let qualification of offer.data.profile.qualifications">
            {{ qualification.name }}
          </li>
        </ul>
      </ng-template>

      <p
        baseTruncate
        class="m-0 d-flex align-items-center"
      >
        {{ offer.data.pspBranch.legalName }}
        <i
          *ngIf="offer.data.pspBranch?.deliveryType"
          [class]="
            offer.data.pspBranch.deliveryType +
            ' fa-solid ms-2 delivery-priority fa-circle-' +
            offer.data.pspBranch.deliveryType
          "
          [ngbTooltip]="
            ('administration.timeToWait.timeToWaitCategory' | translate) +
            ' ' +
            offer.data.pspBranch.deliveryType.toUpperCase()
          "
        ></i>
      </p>
      <p
        baseTruncate
        class="m-0 fw-bold"
      >
        {{ offer.data.hourlyRate | baseFormatDecimal }} €
      </p>
    </div>

    <div class="d-flex flex-nowrap gap-2 my-2 align-items-center">
      <i
        (click)="openRequirementsModal($event, offer.data.profile)"
        [ngClass]="isRequirementsFulfilled ? 'fa-check text-primary' : 'fa-xmark text-light-gray'"
        [ngbTooltip]="
          isRequirementsFulfilled
            ? ('inquiry.allRequirementsFulfilled' | translate)
            : ('inquiry.notAllRequirementsFulfilled' | translate)
        "
        class="fa-solid pointer"
      ></i>
      <i
        (click)="openNoteFromProviderModal($event, offer)"
        [ngClass]="offer.data.note ? 'fa-solid fa-message text-primary' : 'fa-regular fa-message-slash text-light-gray'"
        [ngbTooltip]="
          offer.data.note ? ('tooltip.remarkFromProvider' | translate) : ('tooltip.noRemarksFromProvider' | translate)
        "
        class="mt-1 mb-0 pointer"
      ></i>
      <i
        [ngClass]="offer.data.profile.experience ? 'text-primary' : 'text-light-gray'"
        [ngbTooltip]="
          offer.data.profile.experience
            ? ('tooltip.experienceInCompany' | translate)
            : ('tooltip.noExperienceInCompany' | translate)
        "
        class="fa-solid mt-1 mb-0 fa-building"
      ></i>
      <span class="star">
        <i
          [ngClass]="offer.data.profile.ratingCount ? 'fas text-warning' : 'far text-light-gray'"
          [ngbTooltip]="starTooltip"
          class="fa-fw fa-star"
        ></i>
        <ng-template #starTooltip>
          <base-rating
            *ngIf="offer.data.profile.ratingCount; else noRatingMessage"
            [currentRate]="offer.data.profile.averageRating"
            [hideCount]="true"
            starIconClasses="fs-7"
          ></base-rating>
        </ng-template>
        <ng-template #noRatingMessage>
          {{ 'inquiry.noRatingMessage' | translate }}
        </ng-template>
      </span>
      <img
        [src]="
          offer.data.industrySurcharges
            ? 'assets-global/images/industry-surcharges-' + application.toLowerCase() + '.svg'
            : 'assets-global/images/industry-surcharges-disabled.svg'
        "
        [ngClass]="offer.data.industrySurcharges ? 'pointer' : 'no-pointer'"
        (click)="openIndustrySurchargeModal($event, offer.data.industrySurcharges)"
        [ngbTooltip]="
          offer.data.industrySurcharges
            ? ('tooltip.industrySurcharges' | translate)
            : ('tooltip.noIndustrySurcharges' | translate)
        "
        alt="Industry Surcharges List"
      />
      <base-izs-rating
        [color]="offer.data.pspBranch.izsStatus"
        [isSmallLogo]="true"
        (click)="openIzsInfoModal($event)"
      ></base-izs-rating>
    </div>
  </div>
  <div class="d-flex flex-column">
    <div
      *ngFor="let shiftTime of shiftTimesWithFlex"
      class="inquiry-shift-time d-flex justify-content-end align-items-center"
      [ngClass]="{ 'inquiry-shift-time-flex': shiftTime.type === baseInquiryShiftsWithFlex.flex }"
    >
      <span
        (click)="onFlexLabelClick($event, offer)"
        *ngIf="shiftTime?.type === baseInquiryShiftsWithFlex.flex"
        [ngClass]="{
          'no-pointer':
            !offer.data.isSelected ||
            offer.data.status !== offerStatuses.open ||
            (offer.data.isSelected &&
              !(offer.dates | baseCustomerOfferAvailableShiftTypeExists: baseInquiryShiftsWithFlex.flex)),
          'text-primary': offer.dates | baseCustomerOfferAvailableShiftTypeExists: baseInquiryShiftsWithFlex.flex
        }"
        [ngbTooltip]="flexLabelTooltip"
        class="text-uppercase"
        >{{ 'shiftTimes.flex' | translate }}</span
      >
      <span (click)="onShiftIconClick($event, offer, shiftTime.type)">
        <i
          *ngIf="shiftTime && shiftTime.type !== baseInquiryShiftsWithFlex.flex"
          class="ms-2 fa-fw fa-regular {{ baseShiftIconsEnum[shiftTime.type] }}"
          [ngClass]="{
            'no-pointer':
              !offer.data.isSelected ||
              offer.data.status !== offerStatuses.open ||
              (offer.data.isSelected && !(offer.dates | baseCustomerOfferAvailableShiftTypeExists: shiftTime.type)),
            'text-primary': offer.dates | baseCustomerOfferAvailableShiftTypeExists: shiftTime.type
          }"
          [ngbTooltip]="shiftTimeTooltip"
        ></i>
      </span>
      <ng-template #flexLabelTooltip>
        <div
          [ngClass]="{
            'shift-time-selected-tooltip': offer.data.isSelected && offer.data.status === offerStatuses.open
          }"
        >
          {{ 'work.shift.flexible' | translate }}
        </div>
        <span
          *ngIf="
            offer.data.isSelected &&
            offer.data.status === offerStatuses.open &&
            (offer.dates | baseCustomerOfferAvailableShiftTypeExists: baseInquiryShiftsWithFlex.flex)
          "
          class="fs-8"
          >{{ 'inquiry.flexShiftTimeClickNotification' | translate }}</span
        >
      </ng-template>
      <ng-template #shiftTimeTooltip>
        <div
          [ngClass]="{
            'shift-time-selected-tooltip': offer.data.isSelected && offer.data.status === offerStatuses.open
          }"
        >
          {{ 'shiftTimes.labelLong.' + shiftTime.type | translate }}
        </div>
        <span
          *ngIf="
            offer.data.isSelected &&
            offer.data.status === offerStatuses.open &&
            (offer.dates | baseCustomerOfferAvailableShiftTypeExists: shiftTime.type)
          "
          class="fs-8"
          >{{ 'inquiry.shiftTimeClickNotification' | translate }}</span
        >
      </ng-template>
    </div>
  </div>
</div>
<div class="inquiry-right-content">
  <base-customer-offer-bubble-list
    class="d-flex w-100"
    [offer]="offer"
  ></base-customer-offer-bubble-list>
</div>
<base-customer-offer-actions
  *ngIf="offer.data.isSelected && canAcceptOffers"
  class="inquiry-and-offer-actions"
  [offer]="offer"
  [offerAction]="offerAction"
  [locationWorkCouncilSettings]="locationWorkCouncilSettings"
  (toAssignments)="openOfferInfoModal($event, true)"
></base-customer-offer-actions>

<ng-template #offerInfoPopup>
  <base-customer-offer-info-modal
    (acceptOrRejectOffer)="acceptOrRejectOfferFromInfoModal($event)"
    [assignmentContractSigningStatus]="assignmentInfo?.contracts?.[0]?.signingStatus || signingStatus.unsigned"
    [assignment]="assignmentInfo"
    [inquiryRequirementCategories]="inquiry.requirements || []"
    [inquiry]="inquiry"
    [isAssignmentsAdmin]="hasAdminAssignmentsPermission"
    [modalRef]="modalRef"
    [offer]="offer.data"
    [openOperationInfo]="toAssignmentsTab"
  ></base-customer-offer-info-modal>
</ng-template>

<ng-template #industrySurchargesModal>
  <base-industry-surcharges
    *ngIf="offer.data.industrySurcharges as industrySurcharges"
    [surcharges]="industrySurcharges"
    [showCategoryAndMethod]="true"
  ></base-industry-surcharges>
</ng-template>

<ng-template #requirementsPopup>
  <base-inquiry-requirements-modal
    [candidateRequirements]="offerProfileRequirements"
    [inquiryRequirements]="baseInquiryService.ungroupRequirements(inquiry.requirements)"
  ></base-inquiry-requirements-modal>
</ng-template>
